import { isMobile } from "@digits-shared/helpers/devicesHelper"
import useSession from "@digits-shared/hooks/useSession"
import { AspectCode } from "@digits-shared/session/AspectCode"
import { JWTPermissionFlag } from "@digits-shared/session/jwt/jwtPermissions"
import { useHasPermission } from "src/frontend/components/Shared/Permissions/Requires"
import type FrontendSession from "src/frontend/session"
import {
  FrontendPermissionModule,
  FrontendPermissionSource,
} from "src/frontend/session/permissionModule"

export function useAllowTransactionsTableEdits() {
  const { hasAccessToAspect } = useSession<FrontendSession>()
  const hasRestrictedEdit = hasAccessToAspect(AspectCode.RestrictLedgerEdits)
  const hasUpdateTransactionsPermission = useHasPermission({
    source: FrontendPermissionSource.LegalEntity,
    module: FrontendPermissionModule.Transactions,
    flag: JWTPermissionFlag.Update,
  })
  const hasCreateTransactionsPermission = useHasPermission({
    source: FrontendPermissionSource.LegalEntity,
    module: FrontendPermissionModule.Transactions,
    flag: JWTPermissionFlag.Create,
  })

  // Disabling edits on Mobile until typeahead and UIs are responsive
  const allowCreate = !isMobile && hasCreateTransactionsPermission
  const allowEdits = !isMobile && hasUpdateTransactionsPermission
  const allowBulkEdits = allowEdits && !hasRestrictedEdit

  return { allowCreate, allowEdits, allowBulkEdits }
}
